export class InventoryCountry {
    id: string;
    name: string;
}